import { Injectable } from '@angular/core';
import { Category } from '@shared/definitions';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  categories: BehaviorSubject<Category[]> = new BehaviorSubject<Category[]>([]);
  showCookies: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {}

  setCookies(show) {
    this.showCookies.next(show);
  }

  setCategories(categories: Category[]) {
    this.categories.next(categories);
  }

  getCategories() {
    return this.categories.asObservable();
  }
}
